import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteProjectListing as deleteProjectListingAPI } from '@/api/v4/project-listings.api';
import { QueryKey } from '@/config/query-client';
import { useInvalidateProjectListings } from '@/features/projects/project-listings/use-invalidate-project-listings';
import { notify } from '@/ui/snackbar/notify';

export const useDeleteProjectListing = () => {
  const { t } = useTranslation('projects', {
    keyPrefix: 'listings',
  });
  const queryClient = useQueryClient();
  const invalidateProjectListings = useInvalidateProjectListings();

  const deleteProjectListingMutation = useMutation({
    mutationFn: deleteProjectListingAPI,
    onSuccess: async (_, listing) => {
      notify({ message: t`companyWasRemoved` });
      await invalidateProjectListings();
      await queryClient.invalidateQueries({ queryKey: [QueryKey.Snapshot] });
      await queryClient.invalidateQueries({ queryKey: [QueryKey.Funnel] });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.LastActivities],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.LastActivitiesCount],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.CompanyOptionsCount],
      });
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.CompanyProjectsListings, listing.organization.id],
      });
    },
  });

  return {
    deleteProjectListing: deleteProjectListingMutation.mutateAsync,
    isError: deleteProjectListingMutation.isError,
  };
};
